import { singleo93pzdgfc557 as single } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function conjunctionPredicate(predicates) {
  return predicates.isEmpty_y1axqb_k$() ? Truth_instance : predicates.get_size_woubt6_k$() === 1 ? single(predicates) : new (ConjunctionPredicate())(predicates);
}
var ComparisonPredicateClass;
function ComparisonPredicate() {
  if (ComparisonPredicateClass === VOID) {
    class $ {
      constructor(expectedValue, getter) {
        this.expectedValue_1 = expectedValue;
        this.getter_1 = getter;
      }
      test_kxdenx_k$(value) {
        return equals(this.getter_1(value), this.expectedValue_1);
      }
    }
    initMetadataForClass($, 'ComparisonPredicate');
    ComparisonPredicateClass = $;
  }
  return ComparisonPredicateClass;
}
var TruthClass;
function Truth() {
  if (TruthClass === VOID) {
    class $ {
      test_o6ugz1_k$(value) {
        return true;
      }
      test_kxdenx_k$(value) {
        return this.test_o6ugz1_k$(value);
      }
    }
    initMetadataForObject($, 'Truth');
    TruthClass = $;
  }
  return TruthClass;
}
var Truth_instance;
function Truth_getInstance() {
  return Truth_instance;
}
var ConjunctionPredicateClass;
function ConjunctionPredicate() {
  if (ConjunctionPredicateClass === VOID) {
    class $ {
      constructor(predicates) {
        this.predicates_1 = predicates;
      }
      test_kxdenx_k$(value) {
        var tmp0 = this.predicates_1;
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (!element.test_kxdenx_k$(value)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, 'ConjunctionPredicate');
    ConjunctionPredicateClass = $;
  }
  return ConjunctionPredicateClass;
}
function Predicate$test$ref(p0) {
  return constructCallableReference((p0_0) => p0.test_kxdenx_k$(p0_0), 1, 0, 63, 'test', [p0]);
}
function Truth$test$ref(p0) {
  return constructCallableReference((p0_0) => p0.test_o6ugz1_k$(p0_0), 1, 0, 64, 'test', [p0]);
}
//region block: init
Truth_instance = new (Truth())();
//endregion
//region block: exports
export {
  Truth_instance as Truth_instance578180c81czc,
  Predicate$test$ref as Predicate$test$ref1gcv0vzg86rab,
  Truth$test$ref as Truth$test$ref26ex5sva906mv,
  ComparisonPredicate as ComparisonPredicate21wq2zjdls3fu,
  Truth as Truth1p2zb9jq6ku60,
  conjunctionPredicate as conjunctionPredicate3qd2h4fxtw47e,
};
//endregion

//# sourceMappingURL=Predicate.mjs.map
